module.exports = __webpack_public_path__ + "img/layered-waves-haikei-1.c851d648.svg";